import React, { useState, useRef, useEffect } from 'react';
import { getImageUrlBasedOnContainerWidth } from "@pb/utils/image/getImageUrl";
import { imageTypes } from "@pb/utils/image/getImageUrl";
import { default as isTouchDeviceUtil } from "@pb/utils/isTouchDevice";
import cn from 'classnames';
import Image from "../../ui/Image";
import styles from './ProductImage.module.scss';
const useDevPrefixedUrl = process.env.USE_DEV_PREFIXED_LIQUID_PIXELS_URLS === 'enabled';
const getProductImageSrc = (src, containerWidth) => getImageUrlBasedOnContainerWidth({
    src,
    containerWidth,
    type: imageTypes.PRODUCT_IMAGE,
    useDevPrefixedUrl,
});
const ProductImage = ({ primaryImageId, primaryImage, primaryImageAlt, secondaryImage, secondaryImageAlt, secondaryImageId, useSecondaryAsDefault, isChangeImageOnHoverActive, shouldLazyLoad = true, reserveHeightAspectRatio = '2/3', shouldUseResolver = false, shouldUseNextImage, nextImageProps, shouldUseDirectSrc, imageType, showCenterAlignedImage, resolverSettings, isImageHeightAutoAdjustmentEnabled, shouldShowSkeleton, shouldDelayLazyLoad, lazyLoadDelayMs, handleOnLoad, isDamImage, shouldSetResolverQuality, shouldUseAkamai = false, width, }) => {
    // TODO: useMemo here instead of useState
    const [primaryImageSrc, setPrimaryImageSrc] = useState(primaryImage);
    const [secondaryImageSrc, setSecondaryImageSrc] = useState(secondaryImage);
    const imgRef = useRef(null);
    const isTouchDevice = isTouchDeviceUtil();
    useEffect(() => {
        if (!imgRef.current) {
            return;
        }
        const imageContainer = imgRef.current.parentNode;
        const containerWidth = imageContainer.offsetWidth || 0;
        if (!containerWidth) {
            return;
        }
        if (primaryImage) {
            const resizedProductImage = shouldUseResolver
                ? primaryImage
                : getProductImageSrc(primaryImage, containerWidth);
            setPrimaryImageSrc(resizedProductImage);
        }
        if (secondaryImage) {
            const resizedProductImage = shouldUseResolver
                ? secondaryImage
                : getProductImageSrc(secondaryImage, containerWidth);
            setSecondaryImageSrc(resizedProductImage);
        }
    }, [primaryImage, secondaryImage, imgRef]);
    const imageSrc = useSecondaryAsDefault ? secondaryImageSrc : primaryImageSrc;
    const imageAlt = useSecondaryAsDefault ? secondaryImageAlt : primaryImageAlt;
    const imageDataSrc = useSecondaryAsDefault ? primaryImageSrc : secondaryImageSrc;
    const imageDataAltImage = useSecondaryAsDefault ? primaryImageSrc : secondaryImageSrc;
    const imageDataAltText = useSecondaryAsDefault ? primaryImageAlt : secondaryImageAlt;
    const imageTypeResolved = shouldUseDirectSrc ? '' : imageType || imageTypes.PRODUCT_IMAGE;
    const [showSecondaryImage, setShowSecondaryImage] = useState(false);
    const [isSecondaryImageLoaded, setIsSecondaryImageLoaded] = useState(false);
    const handleMouseEnter = () => {
        if (!secondaryImageSrc || !isChangeImageOnHoverActive || isTouchDevice)
            return;
        setShowSecondaryImage(true);
    };
    const handleMouseLeave = () => {
        if (!secondaryImageSrc || !isChangeImageOnHoverActive || isTouchDevice)
            return;
        setShowSecondaryImage(false);
        setIsSecondaryImageLoaded(false);
    };
    const handleSecondaryImageLoadingComplete = () => {
        setIsSecondaryImageLoaded(true);
    };
    const getReserveHeightStyle = () => {
        return { marginTop: `calc(-100% / (${reserveHeightAspectRatio}))` };
    };
    const reserveHeightStyle = getReserveHeightStyle();
    const onSecondaryListener = Object.assign({}, (secondaryImageSrc &&
        isChangeImageOnHoverActive &&
        !isTouchDevice &&
        (shouldUseNextImage
            ? { onLoadingComplete: handleSecondaryImageLoadingComplete }
            : { onLoad: handleSecondaryImageLoadingComplete })));
    const resolverSettingsForImage = Object.assign({}, (shouldUseResolver &&
        resolverSettings && {
        resolverSettings,
        shouldShowSkeleton: false,
        shouldSetResolverQuality,
    }));
    const dataAttributes = Object.assign({}, (!shouldUseAkamai && {
        'data-src': imageDataSrc,
        'data-altimage': imageDataAltImage,
        'data-alttext': imageDataAltText,
    }));
    return (React.createElement("div", { onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
        React.createElement(Image, Object.assign({ imageId: !isDamImage ? primaryImageId : imageSrc, url: imageSrc || '', altText: imageAlt || '', imageType: imageTypeResolved, className: cn(styles.image, showSecondaryImage && isSecondaryImageLoaded && styles.hideImage, showCenterAlignedImage && styles.squareImage), shouldLazyLoad: shouldLazyLoad, shouldUseDirectSrc: shouldUseDirectSrc, shouldUseNextImage: shouldUseNextImage, shouldSetResolverQuality: shouldSetResolverQuality }, (shouldUseNextImage && Object.assign({}, nextImageProps)), { reserveHeightAspectRatio: reserveHeightAspectRatio }, resolverSettingsForImage, dataAttributes, { isImageHeightAutoAdjustmentEnabled: isImageHeightAutoAdjustmentEnabled, shouldDelayLazyLoad: shouldDelayLazyLoad, lazyLoadDelayMs: lazyLoadDelayMs, handleOnLoad: handleOnLoad, isDamImage: isDamImage, shouldUseResolver: shouldUseResolver, shouldShowSkeleton: shouldShowSkeleton, shouldUseAkamai: shouldUseAkamai, width: width })),
        showSecondaryImage && (React.createElement(Image, Object.assign({ imageId: secondaryImageId, url: (!shouldUseAkamai && imageDataAltImage) || '', altText: imageDataAltText || '', imageType: imageTypeResolved, className: cn(styles.image, (!showSecondaryImage || !isSecondaryImageLoaded) && styles.hideImage), style: reserveHeightStyle, shouldLazyLoad: false, shouldUseDirectSrc: shouldUseDirectSrc, shouldUseNextImage: shouldUseNextImage }, (shouldUseNextImage && Object.assign({}, nextImageProps)), dataAttributes, { reserveHeightAspectRatio: reserveHeightAspectRatio }, resolverSettingsForImage, onSecondaryListener, { isImageHeightAutoAdjustmentEnabled: isImageHeightAutoAdjustmentEnabled, handleOnLoad: handleOnLoad, shouldUseResolver: shouldUseResolver, shouldUseAkamai: shouldUseAkamai, width: width })))));
};
export default ProductImage;
//# sourceMappingURL=ProductImage.js.map